export default "__VITE_ASSET__c5acc7bc__"